import { organizationsAuditListDef } from '../../../../backend/features/organizations/shared';
import { mapAuditListRequest } from '@juvare/platform-sdk-react/ui/features/audit';
import { useTypedPlatformFunctionResponse } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
export function useOrganizationsAuditBackendDataProvider(request, additionalParams) {
    const { request: listAuditRequest, error: mapError } = mapAuditListRequest(request, additionalParams);
    const { data, isLoading, error, mutate } = useTypedPlatformFunctionResponse(organizationsAuditListDef, listAuditRequest);
    if (listAuditRequest) {
        return {
            data: data
                ? {
                    filteredRowCount: data.total,
                    rows: data.rows,
                }
                : undefined,
            error,
            isLoading,
            reload: mutate,
        };
    }
    return {
        data: undefined,
        error: new Error(mapError),
        reload: () => { },
    };
}
